// removed by extract-text-webpack-plugin
module.exports = {"SplitPickup":"SplitPickup__SplitPickup__2KGWA","LeftSide":"SplitPickup__LeftSide__31Mbn","RightSide":"SplitPickup__RightSide__sqXA_","MiddleSide":"SplitPickup__MiddleSide__2KbuQ"};


//////////////////
// WEBPACK FOOTER
// ./src/components/SplitPickup/SplitPickup.css
// module id = 260
// module chunks = 1